
export enum AffiliationPartnerProgram {
  BOOKING = "BOOKING",
  AWIN = "AWIN",
  CJ = "CJ"
}

export enum AffiliationPartner {
  BOOKING = "BOOKING",
  EDREAMS = "EDREAMS",
  ETHIAD = "ETHIAD",
  EUROPCAR = "EUROPCAR",
  LASTMINUTE = "LASTMINUTE",
  OPODO = "OPODO",
  QTAR = "QTAR",
  TIQETS = "TIQETS",
  TRIPADVISOR = "TRIPADVISOR",
  VOLAGRATIS = "VOLAGRATIS",
  RENTALCARS = "RENTALCARS",
  AIRFRANCE = "AIRFRANCE",
  AUTOEUROPE = "AUTOEUROPE",
  HOMEAWAY = "HOMEAWAY",
  IBERIA = "IBERIA",
  KIWI = "KIWI",
  SIXT = "SIXT",
  VUELING = "VUELING"
}

export class AffiliationPartnerData {
  static readonly BOOKING = new AffiliationPartnerData(
    AffiliationPartner.BOOKING,
    AffiliationPartnerProgram.BOOKING,
    null,
    "Booking"
  );

  static readonly EDREAMS = new AffiliationPartnerData(
    AffiliationPartner.EDREAMS,
    AffiliationPartnerProgram.AWIN,
    "9457",
    "eDreams"
  );

  static readonly ETHIAD = new AffiliationPartnerData(
    AffiliationPartner.ETHIAD,
    AffiliationPartnerProgram.AWIN,
    "7983",
    "Ethiad"
  );

  static readonly EUROPCAR = new AffiliationPartnerData(
    AffiliationPartner.EUROPCAR,
    AffiliationPartnerProgram.AWIN,
    "7629",
    "Europcar"
  );

  static readonly LASTMINUTE = new AffiliationPartnerData(
    AffiliationPartner.LASTMINUTE,
    AffiliationPartnerProgram.AWIN,
    "12374",
    "Lastminute"
  );

  static readonly OPODO = new AffiliationPartnerData(
    AffiliationPartner.OPODO,
    AffiliationPartnerProgram.AWIN,
    "9461",
    "Opodo"
  );

  static readonly QTAR = new AffiliationPartnerData(
    AffiliationPartner.QTAR,
    AffiliationPartnerProgram.AWIN,
    "10143",
    "Qtar"
  );

  static readonly TIQETS = new AffiliationPartnerData(
    AffiliationPartner.TIQETS,
    AffiliationPartnerProgram.AWIN,
    "12427",
    "Tiqets"
  );

  static readonly TRIPADVISOR = new AffiliationPartnerData(
    AffiliationPartner.TRIPADVISOR,
    AffiliationPartnerProgram.AWIN,
    "9456",
    "TripAdvisor"
  );

  static readonly VOLAGRATIS = new AffiliationPartnerData(
    AffiliationPartner.VOLAGRATIS,
    AffiliationPartnerProgram.AWIN,
    "9432",
    "Volagratis"
  );

  static readonly RENTALCARS = new AffiliationPartnerData(
    AffiliationPartner.RENTALCARS,
    AffiliationPartnerProgram.CJ,
    "9208749-12595001",
    "Rental Cars"
  );

  static readonly AUTOEUROPE = new AffiliationPartnerData(
    AffiliationPartner.AUTOEUROPE,
    AffiliationPartnerProgram.CJ,
    "9208749-13820707",
    "Auto Europe Car Rentals"
  );

  static readonly IBERIA = new AffiliationPartnerData(
    AffiliationPartner.IBERIA,
    AffiliationPartnerProgram.CJ,
    "9208749-12119547",
    "Iberia"
  );

  static readonly KIWI = new AffiliationPartnerData(
    AffiliationPartner.KIWI,
    AffiliationPartnerProgram.CJ,
    "9208749-12624156",
    "Kiwi"
  );

  static readonly SIXT = new AffiliationPartnerData(
    AffiliationPartner.SIXT,
    AffiliationPartnerProgram.CJ,
    "9208749-12490577",
    "Sixt"
  );

  static readonly VUELING = new AffiliationPartnerData(
    AffiliationPartner.VUELING,
    AffiliationPartnerProgram.CJ,
    "9208749-11047906",
    "Vueling"
  );

  private constructor(
    public readonly key: AffiliationPartner,
    public readonly partnerProgram: AffiliationPartnerProgram,
    public readonly partnerId: string,
    public readonly label: string,
  ) { }

  static values(): AffiliationPartnerData[] {
    return [AffiliationPartnerData.BOOKING,
    AffiliationPartnerData.EDREAMS,
    AffiliationPartnerData.ETHIAD,
    AffiliationPartnerData.EUROPCAR,
    AffiliationPartnerData.LASTMINUTE,
    AffiliationPartnerData.OPODO,
    AffiliationPartnerData.QTAR,
    AffiliationPartnerData.TIQETS,
    AffiliationPartnerData.TRIPADVISOR,
    AffiliationPartnerData.VOLAGRATIS,
    AffiliationPartnerData.RENTALCARS,
    AffiliationPartnerData.AUTOEUROPE,
    AffiliationPartnerData.IBERIA,
    AffiliationPartnerData.KIWI,
    AffiliationPartnerData.SIXT,
    AffiliationPartnerData.VUELING];
  }

  static get(key: AffiliationPartner) {
    return AffiliationPartnerData.values().find((value) => value.key === key);
  }

  toString() {
    return this.key;
  }
}
